import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=1f786052&scoped=true&"
import script from "./UploadPicture.vue?vue&type=script&lang=js&"
export * from "./UploadPicture.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=1f786052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f786052",
  null
  
)

export default component.exports